import dynamic from 'next/dynamic';
import { twMerge } from 'tailwind-merge';

import Anchor from 'components/Anchor';

import useDialog from 'hooks/useDialog';
import useExclusiveOffer from 'hooks/useExclusiveOffer';
import useUtmsFromSession from 'hooks/useUtmsFromSession';

import { sendEvent } from 'lib/gtag';
import { toOfferRedirectLink } from 'lib/links';

const CouponDialog = dynamic(
  () => import('../../../../pages/Offer/Main/GoToStoreButton/CouponDialog'),
  {
    ssr: false,
  }
);

const COMMON_LINK_STYLES =
  'relative flex h-full select-none flex-col justify-between rounded-4 border border-neutral-high-200 bg-neutral-high-100 p-4 shadow-sm transition-shadow hover:shadow-md dark:border-neutral-low-400 dark:bg-neutral-low-400 lg:p-6 lg:pb-3 lg:hover:ease-in';

const CardWrapper = ({
  children,
  offerCoupon,
  offerSlug,
  gaEventCategory,
  offerUserVisibility,
  offerId,
  className,
}) => {
  const { showDialog } = useDialog();
  const { isOfferBlocked } = useExclusiveOffer();
  const { utmParams } = useUtmsFromSession();

  if (offerCoupon) {
    return (
      <button
        className={twMerge(COMMON_LINK_STYLES, className)}
        disabled={isOfferBlocked(offerUserVisibility, offerSlug)}
        size="size1"
        type="primary"
        onClick={() => {
          sendEvent({
            action: 'modal_coupon_open',
            category: 'active_offer_buy',
          });
          showDialog(CouponDialog, {
            offerCoupon,
            offerId,
            utmParams,
            gaEventCategory,
          });
        }}
      >
        {children}
      </button>
    );
  }

  return (
    <Anchor
      as="a"
      className={twMerge(COMMON_LINK_STYLES, className)}
      disabled={isOfferBlocked(offerUserVisibility, offerSlug)}
      href={toOfferRedirectLink(offerId, utmParams)}
      size="size1"
      target="_blank"
      type="primary"
      onClick={() => {
        sendEvent({
          action: 'go_store',
          category: gaEventCategory,
        });
      }}
    >
      {children}
    </Anchor>
  );
};
export default CardWrapper;
